const listHasLink = () => {
    document.addEventListener('click', (ev) => {
        if (!ev.target.classList.contains('ume-starter-list-has-link')) return;
        let link = ev.target.querySelector('a');
        if (link !== null) {
            link.click();
        }

    })

}
listHasLink();